import Logger from './logger';

// Normalizes a raw SDK version string to `pkg:version` form for Datadog.
// Old footprint-js bundles in the wild (and the Postmate model on every
// version) deliver a bare semver with no package prefix; we attach the
// canonical @onefootprint/footprint-js prefix in that case. Anything that
// already contains a colon is trusted and returned unchanged.
export const formatClientVersion = (sdkVersion: string | null | undefined): string => {
  if (!sdkVersion) return '';
  return sdkVersion.includes(':') ? sdkVersion : `@onefootprint/footprint-js:${sdkVersion}`;
};

export const logClientVersion = (sdkVersion: string | null | undefined): void => {
  const clientVersion = formatClientVersion(sdkVersion);
  if (clientVersion) {
    Logger.appendGlobalContext({ client_version: clientVersion });
  }
};
